import { QuestionAnswer } from '@empathy/global/data';

export class SubmitAnswerRequest {
  projectId: string;
  answers: QuestionAnswer[];
}
